/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Webdo Admin API
 * OpenAPI contract for the Webdo admin frontend.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery,
  useQueryClient
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminAiDatabaseCatalogResponse,
  AdminAiDatabaseMoveDto,
  AdminAiOperationsResponse,
  AdminAiUsageResponse,
  AdminAiWorkspaceDatabaseResponse,
  AdminApplicationsResponse,
  AdminCatalogWorkspacesResponse,
  AdminChangePartnerAccountStatusRequest,
  AdminChangePartnerCommissionRequest,
  AdminDashboardResponse,
  AdminHistoryResponse,
  AdminIndustriesResponse,
  AdminOperationsResponse,
  AdminPartnerAccountListResponse,
  AdminPartnerDetailResponse,
  AdminPartnerListResponse,
  AdminUserDetailResponse,
  AdminUserListResponse,
  AdminUsersResponse,
  AiCreditBalanceDto,
  AiCreditHistoryDto,
  ApiErrorResponse,
  CreateAdminAiWorkspaceDatabaseMoveRequest,
  GetAdminAiCreditsParams,
  GetAdminAiUsageParams,
  GrantAdminAiCreditsRequest,
  ListAdminApplicationWorkspacesParams,
  ListAdminHistoryParams,
  ListAdminIndustryWorkspacesParams,
  ListAdminPartnerAccountsParams,
  ListAdminPartnersParams,
  ListAdminSupportConversationsParams,
  ListAdminUsersParams,
  SendAdminSupportMessageRequest,
  SupportConversationDetailDto,
  SupportConversationListResponse,
  UpdateAdminSupportConversationStatusRequest
} from '../schemas';

import { orvalFetch } from '../../../lib/orvalFetch';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetAdminAiCreditsUrl = (workspaceUuid: string,
    params?: GetAdminAiCreditsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/workspaces/${workspaceUuid}/ai-credits?${stringifiedParams}` : `/admin/workspaces/${workspaceUuid}/ai-credits`
}

/**
 * @summary Read AI credits.
 */
export const getAdminAiCredits = async (workspaceUuid: string,
    params?: GetAdminAiCreditsParams, options?: RequestInit): Promise<AiCreditHistoryDto> => {

  return orvalFetch<AiCreditHistoryDto>(getGetAdminAiCreditsUrl(workspaceUuid,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminAiCreditsQueryKey = (workspaceUuid: string,
    params?: GetAdminAiCreditsParams,) => {
    return [
    `/admin/workspaces/${workspaceUuid}/ai-credits`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminAiCreditsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAiCredits>>, TError = ApiErrorResponse>(workspaceUuid: string,
    params?: GetAdminAiCreditsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiCredits>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminAiCreditsQueryKey(workspaceUuid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAiCredits>>> = ({ signal }) => getAdminAiCredits(workspaceUuid,params, { signal });





   return  { queryKey, queryFn, enabled: workspaceUuid !== null && workspaceUuid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAiCredits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminAiCreditsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAiCredits>>>
export type GetAdminAiCreditsQueryError = ApiErrorResponse


export function useGetAdminAiCredits<TData = Awaited<ReturnType<typeof getAdminAiCredits>>, TError = ApiErrorResponse>(
 workspaceUuid: string,
    params: undefined |  GetAdminAiCreditsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiCredits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminAiCredits>>,
          TError,
          Awaited<ReturnType<typeof getAdminAiCredits>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminAiCredits<TData = Awaited<ReturnType<typeof getAdminAiCredits>>, TError = ApiErrorResponse>(
 workspaceUuid: string,
    params?: GetAdminAiCreditsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiCredits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminAiCredits>>,
          TError,
          Awaited<ReturnType<typeof getAdminAiCredits>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminAiCredits<TData = Awaited<ReturnType<typeof getAdminAiCredits>>, TError = ApiErrorResponse>(
 workspaceUuid: string,
    params?: GetAdminAiCreditsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiCredits>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read AI credits.
 */

export function useGetAdminAiCredits<TData = Awaited<ReturnType<typeof getAdminAiCredits>>, TError = ApiErrorResponse>(
 workspaceUuid: string,
    params?: GetAdminAiCreditsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiCredits>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminAiCreditsQueryOptions(workspaceUuid,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}



/**
 * @summary Read AI credits.
 */
export const useSetGetAdminAiCreditsQueryData = () => {
  const queryClient = useQueryClient();
  return (workspaceUuid: string,
    params: GetAdminAiCreditsParams | undefined,updater: Awaited<ReturnType<typeof getAdminAiCredits>> | undefined | ((old: Awaited<ReturnType<typeof getAdminAiCredits>> | undefined) => Awaited<ReturnType<typeof getAdminAiCredits>> | undefined)) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof getAdminAiCredits>>>({ queryKey: getGetAdminAiCreditsQueryKey(workspaceUuid,params) }, updater);
  };
}

/**
 * @summary Read AI credits.
 */
export const useGetGetAdminAiCreditsQueryData = () => {
  const queryClient = useQueryClient();
  return (workspaceUuid: string,
    params?: GetAdminAiCreditsParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof getAdminAiCredits>>>(getGetAdminAiCreditsQueryKey(workspaceUuid,params));
}


export const getGrantAdminAiCreditsUrl = (workspaceUuid: string,) => {




  return `/admin/workspaces/${workspaceUuid}/ai-credits`
}

/**
 * @summary Assign AI credits to a workspace.
 */
export const grantAdminAiCredits = async (workspaceUuid: string,
    grantAdminAiCreditsRequest: GrantAdminAiCreditsRequest, options?: RequestInit): Promise<AiCreditBalanceDto> => {

  return orvalFetch<AiCreditBalanceDto>(getGrantAdminAiCreditsUrl(workspaceUuid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(grantAdminAiCreditsRequest)
  }
);}





export const getGrantAdminAiCreditsMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof grantAdminAiCredits>>, TError,{workspaceUuid: string;data: GrantAdminAiCreditsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof grantAdminAiCredits>>, TError,{workspaceUuid: string;data: GrantAdminAiCreditsRequest}, TContext> => {

const mutationKey = ['grantAdminAiCredits'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof grantAdminAiCredits>>, {workspaceUuid: string;data: GrantAdminAiCreditsRequest}> = (props) => {
          const {workspaceUuid,data} = props ?? {};

          return  grantAdminAiCredits(workspaceUuid,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GrantAdminAiCreditsMutationResult = NonNullable<Awaited<ReturnType<typeof grantAdminAiCredits>>>
    export type GrantAdminAiCreditsMutationBody = GrantAdminAiCreditsRequest
    export type GrantAdminAiCreditsMutationError = ApiErrorResponse

    /**
 * @summary Assign AI credits to a workspace.
 */
export const useGrantAdminAiCredits = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof grantAdminAiCredits>>, TError,{workspaceUuid: string;data: GrantAdminAiCreditsRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof grantAdminAiCredits>>,
        TError,
        {workspaceUuid: string;data: GrantAdminAiCreditsRequest},
        TContext
      > => {
      return useMutation(getGrantAdminAiCreditsMutationOptions(options), queryClient);
    }
    export const getGetAdminAiDatabasesUrl = () => {




  return `/admin/ai/databases`
}

/**
 * @summary List private AI database availability and assigned workspace counts.
 */
export const getAdminAiDatabases = async ( options?: RequestInit): Promise<AdminAiDatabaseCatalogResponse> => {

  return orvalFetch<AdminAiDatabaseCatalogResponse>(getGetAdminAiDatabasesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminAiDatabasesQueryKey = () => {
    return [
    `/admin/ai/databases`
    ] as const;
    }


export const getGetAdminAiDatabasesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAiDatabases>>, TError = ApiErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiDatabases>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminAiDatabasesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAiDatabases>>> = ({ signal }) => getAdminAiDatabases({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAiDatabases>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminAiDatabasesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAiDatabases>>>
export type GetAdminAiDatabasesQueryError = ApiErrorResponse


export function useGetAdminAiDatabases<TData = Awaited<ReturnType<typeof getAdminAiDatabases>>, TError = ApiErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiDatabases>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminAiDatabases>>,
          TError,
          Awaited<ReturnType<typeof getAdminAiDatabases>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminAiDatabases<TData = Awaited<ReturnType<typeof getAdminAiDatabases>>, TError = ApiErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiDatabases>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminAiDatabases>>,
          TError,
          Awaited<ReturnType<typeof getAdminAiDatabases>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminAiDatabases<TData = Awaited<ReturnType<typeof getAdminAiDatabases>>, TError = ApiErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiDatabases>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List private AI database availability and assigned workspace counts.
 */

export function useGetAdminAiDatabases<TData = Awaited<ReturnType<typeof getAdminAiDatabases>>, TError = ApiErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiDatabases>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminAiDatabasesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}



/**
 * @summary List private AI database availability and assigned workspace counts.
 */
export const useSetGetAdminAiDatabasesQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof getAdminAiDatabases>> | undefined | ((old: Awaited<ReturnType<typeof getAdminAiDatabases>> | undefined) => Awaited<ReturnType<typeof getAdminAiDatabases>> | undefined)) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof getAdminAiDatabases>>>({ queryKey: getGetAdminAiDatabasesQueryKey() }, updater);
  };
}

/**
 * @summary List private AI database availability and assigned workspace counts.
 */
export const useGetGetAdminAiDatabasesQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof getAdminAiDatabases>>>(getGetAdminAiDatabasesQueryKey());
}


export const getGetAdminAiOperationsUrl = () => {




  return `/admin/operations/ai`
}

/**
 * @summary Get recorded AI inference job counts and recent failures across assigned workspaces.
 */
export const getAdminAiOperations = async ( options?: RequestInit): Promise<AdminAiOperationsResponse> => {

  return orvalFetch<AdminAiOperationsResponse>(getGetAdminAiOperationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminAiOperationsQueryKey = () => {
    return [
    `/admin/operations/ai`
    ] as const;
    }


export const getGetAdminAiOperationsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAiOperations>>, TError = ApiErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiOperations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminAiOperationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAiOperations>>> = ({ signal }) => getAdminAiOperations({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAiOperations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminAiOperationsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAiOperations>>>
export type GetAdminAiOperationsQueryError = ApiErrorResponse


export function useGetAdminAiOperations<TData = Awaited<ReturnType<typeof getAdminAiOperations>>, TError = ApiErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiOperations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminAiOperations>>,
          TError,
          Awaited<ReturnType<typeof getAdminAiOperations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminAiOperations<TData = Awaited<ReturnType<typeof getAdminAiOperations>>, TError = ApiErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiOperations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminAiOperations>>,
          TError,
          Awaited<ReturnType<typeof getAdminAiOperations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminAiOperations<TData = Awaited<ReturnType<typeof getAdminAiOperations>>, TError = ApiErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiOperations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get recorded AI inference job counts and recent failures across assigned workspaces.
 */

export function useGetAdminAiOperations<TData = Awaited<ReturnType<typeof getAdminAiOperations>>, TError = ApiErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiOperations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminAiOperationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}



/**
 * @summary Get recorded AI inference job counts and recent failures across assigned workspaces.
 */
export const useSetGetAdminAiOperationsQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof getAdminAiOperations>> | undefined | ((old: Awaited<ReturnType<typeof getAdminAiOperations>> | undefined) => Awaited<ReturnType<typeof getAdminAiOperations>> | undefined)) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof getAdminAiOperations>>>({ queryKey: getGetAdminAiOperationsQueryKey() }, updater);
  };
}

/**
 * @summary Get recorded AI inference job counts and recent failures across assigned workspaces.
 */
export const useGetGetAdminAiOperationsQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof getAdminAiOperations>>>(getGetAdminAiOperationsQueryKey());
}


export const getGetAdminAiUsageUrl = (params?: GetAdminAiUsageParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/ai/usage?${stringifiedParams}` : `/admin/ai/usage`
}

/**
 * @summary Get private AI usage analytics and API-equivalent cost estimates for platform administrators.
 */
export const getAdminAiUsage = async (params?: GetAdminAiUsageParams, options?: RequestInit): Promise<AdminAiUsageResponse> => {

  return orvalFetch<AdminAiUsageResponse>(getGetAdminAiUsageUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminAiUsageQueryKey = (params?: GetAdminAiUsageParams,) => {
    return [
    `/admin/ai/usage`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminAiUsageQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAiUsage>>, TError = ApiErrorResponse>(params?: GetAdminAiUsageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiUsage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminAiUsageQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAiUsage>>> = ({ signal }) => getAdminAiUsage(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAiUsage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminAiUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAiUsage>>>
export type GetAdminAiUsageQueryError = ApiErrorResponse


export function useGetAdminAiUsage<TData = Awaited<ReturnType<typeof getAdminAiUsage>>, TError = ApiErrorResponse>(
 params: undefined |  GetAdminAiUsageParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiUsage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminAiUsage>>,
          TError,
          Awaited<ReturnType<typeof getAdminAiUsage>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminAiUsage<TData = Awaited<ReturnType<typeof getAdminAiUsage>>, TError = ApiErrorResponse>(
 params?: GetAdminAiUsageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiUsage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminAiUsage>>,
          TError,
          Awaited<ReturnType<typeof getAdminAiUsage>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminAiUsage<TData = Awaited<ReturnType<typeof getAdminAiUsage>>, TError = ApiErrorResponse>(
 params?: GetAdminAiUsageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiUsage>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get private AI usage analytics and API-equivalent cost estimates for platform administrators.
 */

export function useGetAdminAiUsage<TData = Awaited<ReturnType<typeof getAdminAiUsage>>, TError = ApiErrorResponse>(
 params?: GetAdminAiUsageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiUsage>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminAiUsageQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}



/**
 * @summary Get private AI usage analytics and API-equivalent cost estimates for platform administrators.
 */
export const useSetGetAdminAiUsageQueryData = () => {
  const queryClient = useQueryClient();
  return (params: GetAdminAiUsageParams | undefined,updater: Awaited<ReturnType<typeof getAdminAiUsage>> | undefined | ((old: Awaited<ReturnType<typeof getAdminAiUsage>> | undefined) => Awaited<ReturnType<typeof getAdminAiUsage>> | undefined)) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof getAdminAiUsage>>>({ queryKey: getGetAdminAiUsageQueryKey(params) }, updater);
  };
}

/**
 * @summary Get private AI usage analytics and API-equivalent cost estimates for platform administrators.
 */
export const useGetGetAdminAiUsageQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: GetAdminAiUsageParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof getAdminAiUsage>>>(getGetAdminAiUsageQueryKey(params));
}


export const getGetAdminAiWorkspaceDatabaseUrl = (workspaceUuid: string,) => {




  return `/admin/ai/workspaces/${workspaceUuid}/database`
}

/**
 * @summary Get the AI database placement and latest move of an existing workspace.
 */
export const getAdminAiWorkspaceDatabase = async (workspaceUuid: string, options?: RequestInit): Promise<AdminAiWorkspaceDatabaseResponse> => {

  return orvalFetch<AdminAiWorkspaceDatabaseResponse>(getGetAdminAiWorkspaceDatabaseUrl(workspaceUuid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminAiWorkspaceDatabaseQueryKey = (workspaceUuid: string,) => {
    return [
    `/admin/ai/workspaces/${workspaceUuid}/database`
    ] as const;
    }


export const getGetAdminAiWorkspaceDatabaseQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAiWorkspaceDatabase>>, TError = ApiErrorResponse>(workspaceUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiWorkspaceDatabase>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminAiWorkspaceDatabaseQueryKey(workspaceUuid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAiWorkspaceDatabase>>> = ({ signal }) => getAdminAiWorkspaceDatabase(workspaceUuid, { signal });





   return  { queryKey, queryFn, enabled: workspaceUuid !== null && workspaceUuid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAiWorkspaceDatabase>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminAiWorkspaceDatabaseQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAiWorkspaceDatabase>>>
export type GetAdminAiWorkspaceDatabaseQueryError = ApiErrorResponse


export function useGetAdminAiWorkspaceDatabase<TData = Awaited<ReturnType<typeof getAdminAiWorkspaceDatabase>>, TError = ApiErrorResponse>(
 workspaceUuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiWorkspaceDatabase>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminAiWorkspaceDatabase>>,
          TError,
          Awaited<ReturnType<typeof getAdminAiWorkspaceDatabase>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminAiWorkspaceDatabase<TData = Awaited<ReturnType<typeof getAdminAiWorkspaceDatabase>>, TError = ApiErrorResponse>(
 workspaceUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiWorkspaceDatabase>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminAiWorkspaceDatabase>>,
          TError,
          Awaited<ReturnType<typeof getAdminAiWorkspaceDatabase>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminAiWorkspaceDatabase<TData = Awaited<ReturnType<typeof getAdminAiWorkspaceDatabase>>, TError = ApiErrorResponse>(
 workspaceUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiWorkspaceDatabase>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the AI database placement and latest move of an existing workspace.
 */

export function useGetAdminAiWorkspaceDatabase<TData = Awaited<ReturnType<typeof getAdminAiWorkspaceDatabase>>, TError = ApiErrorResponse>(
 workspaceUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiWorkspaceDatabase>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminAiWorkspaceDatabaseQueryOptions(workspaceUuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}



/**
 * @summary Get the AI database placement and latest move of an existing workspace.
 */
export const useSetGetAdminAiWorkspaceDatabaseQueryData = () => {
  const queryClient = useQueryClient();
  return (workspaceUuid: string,updater: Awaited<ReturnType<typeof getAdminAiWorkspaceDatabase>> | undefined | ((old: Awaited<ReturnType<typeof getAdminAiWorkspaceDatabase>> | undefined) => Awaited<ReturnType<typeof getAdminAiWorkspaceDatabase>> | undefined)) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof getAdminAiWorkspaceDatabase>>>({ queryKey: getGetAdminAiWorkspaceDatabaseQueryKey(workspaceUuid) }, updater);
  };
}

/**
 * @summary Get the AI database placement and latest move of an existing workspace.
 */
export const useGetGetAdminAiWorkspaceDatabaseQueryData = () => {
  const queryClient = useQueryClient();
  return (workspaceUuid: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof getAdminAiWorkspaceDatabase>>>(getGetAdminAiWorkspaceDatabaseQueryKey(workspaceUuid));
}


export const getCreateAdminAiWorkspaceDatabaseMoveUrl = (workspaceUuid: string,) => {




  return `/admin/ai/workspaces/${workspaceUuid}/database-moves`
}

/**
 * @summary Queue or replay an idempotent AI database move for an existing workspace.
 */
export const createAdminAiWorkspaceDatabaseMove = async (workspaceUuid: string,
    createAdminAiWorkspaceDatabaseMoveRequest: CreateAdminAiWorkspaceDatabaseMoveRequest, options?: RequestInit): Promise<AdminAiDatabaseMoveDto> => {

  return orvalFetch<AdminAiDatabaseMoveDto>(getCreateAdminAiWorkspaceDatabaseMoveUrl(workspaceUuid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createAdminAiWorkspaceDatabaseMoveRequest)
  }
);}





export const getCreateAdminAiWorkspaceDatabaseMoveMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminAiWorkspaceDatabaseMove>>, TError,{workspaceUuid: string;data: CreateAdminAiWorkspaceDatabaseMoveRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAdminAiWorkspaceDatabaseMove>>, TError,{workspaceUuid: string;data: CreateAdminAiWorkspaceDatabaseMoveRequest}, TContext> => {

const mutationKey = ['createAdminAiWorkspaceDatabaseMove'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminAiWorkspaceDatabaseMove>>, {workspaceUuid: string;data: CreateAdminAiWorkspaceDatabaseMoveRequest}> = (props) => {
          const {workspaceUuid,data} = props ?? {};

          return  createAdminAiWorkspaceDatabaseMove(workspaceUuid,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminAiWorkspaceDatabaseMoveMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminAiWorkspaceDatabaseMove>>>
    export type CreateAdminAiWorkspaceDatabaseMoveMutationBody = CreateAdminAiWorkspaceDatabaseMoveRequest
    export type CreateAdminAiWorkspaceDatabaseMoveMutationError = ApiErrorResponse

    /**
 * @summary Queue or replay an idempotent AI database move for an existing workspace.
 */
export const useCreateAdminAiWorkspaceDatabaseMove = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminAiWorkspaceDatabaseMove>>, TError,{workspaceUuid: string;data: CreateAdminAiWorkspaceDatabaseMoveRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAdminAiWorkspaceDatabaseMove>>,
        TError,
        {workspaceUuid: string;data: CreateAdminAiWorkspaceDatabaseMoveRequest},
        TContext
      > => {
      return useMutation(getCreateAdminAiWorkspaceDatabaseMoveMutationOptions(options), queryClient);
    }
    export const getListAdminApplicationWorkspacesUrl = (code: string,
    params?: ListAdminApplicationWorkspacesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/applications/${code}/workspaces?${stringifiedParams}` : `/admin/applications/${code}/workspaces`
}

/**
 * @summary List workspaces with an active application installation.
 */
export const listAdminApplicationWorkspaces = async (code: string,
    params?: ListAdminApplicationWorkspacesParams, options?: RequestInit): Promise<AdminCatalogWorkspacesResponse> => {

  return orvalFetch<AdminCatalogWorkspacesResponse>(getListAdminApplicationWorkspacesUrl(code,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminApplicationWorkspacesQueryKey = (code: string,
    params?: ListAdminApplicationWorkspacesParams,) => {
    return [
    `/admin/applications/${code}/workspaces`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminApplicationWorkspacesQueryOptions = <TData = Awaited<ReturnType<typeof listAdminApplicationWorkspaces>>, TError = ApiErrorResponse>(code: string,
    params?: ListAdminApplicationWorkspacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminApplicationWorkspaces>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminApplicationWorkspacesQueryKey(code,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminApplicationWorkspaces>>> = ({ signal }) => listAdminApplicationWorkspaces(code,params, { signal });





   return  { queryKey, queryFn, enabled: code !== null && code !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminApplicationWorkspaces>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminApplicationWorkspacesQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminApplicationWorkspaces>>>
export type ListAdminApplicationWorkspacesQueryError = ApiErrorResponse


export function useListAdminApplicationWorkspaces<TData = Awaited<ReturnType<typeof listAdminApplicationWorkspaces>>, TError = ApiErrorResponse>(
 code: string,
    params: undefined |  ListAdminApplicationWorkspacesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminApplicationWorkspaces>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminApplicationWorkspaces>>,
          TError,
          Awaited<ReturnType<typeof listAdminApplicationWorkspaces>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminApplicationWorkspaces<TData = Awaited<ReturnType<typeof listAdminApplicationWorkspaces>>, TError = ApiErrorResponse>(
 code: string,
    params?: ListAdminApplicationWorkspacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminApplicationWorkspaces>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminApplicationWorkspaces>>,
          TError,
          Awaited<ReturnType<typeof listAdminApplicationWorkspaces>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminApplicationWorkspaces<TData = Awaited<ReturnType<typeof listAdminApplicationWorkspaces>>, TError = ApiErrorResponse>(
 code: string,
    params?: ListAdminApplicationWorkspacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminApplicationWorkspaces>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List workspaces with an active application installation.
 */

export function useListAdminApplicationWorkspaces<TData = Awaited<ReturnType<typeof listAdminApplicationWorkspaces>>, TError = ApiErrorResponse>(
 code: string,
    params?: ListAdminApplicationWorkspacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminApplicationWorkspaces>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminApplicationWorkspacesQueryOptions(code,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}



/**
 * @summary List workspaces with an active application installation.
 */
export const useSetListAdminApplicationWorkspacesQueryData = () => {
  const queryClient = useQueryClient();
  return (code: string,
    params: ListAdminApplicationWorkspacesParams | undefined,updater: Awaited<ReturnType<typeof listAdminApplicationWorkspaces>> | undefined | ((old: Awaited<ReturnType<typeof listAdminApplicationWorkspaces>> | undefined) => Awaited<ReturnType<typeof listAdminApplicationWorkspaces>> | undefined)) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof listAdminApplicationWorkspaces>>>({ queryKey: getListAdminApplicationWorkspacesQueryKey(code,params) }, updater);
  };
}

/**
 * @summary List workspaces with an active application installation.
 */
export const useGetListAdminApplicationWorkspacesQueryData = () => {
  const queryClient = useQueryClient();
  return (code: string,
    params?: ListAdminApplicationWorkspacesParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof listAdminApplicationWorkspaces>>>(getListAdminApplicationWorkspacesQueryKey(code,params));
}


export const getGetAdminApplicationsUrl = () => {




  return `/admin/applications`
}

/**
 * @summary Get active application adoption statistics across platform workspaces.
 */
export const getAdminApplications = async ( options?: RequestInit): Promise<AdminApplicationsResponse> => {

  return orvalFetch<AdminApplicationsResponse>(getGetAdminApplicationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminApplicationsQueryKey = () => {
    return [
    `/admin/applications`
    ] as const;
    }


export const getGetAdminApplicationsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminApplications>>, TError = ApiErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminApplications>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminApplicationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminApplications>>> = ({ signal }) => getAdminApplications({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminApplications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminApplicationsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminApplications>>>
export type GetAdminApplicationsQueryError = ApiErrorResponse


export function useGetAdminApplications<TData = Awaited<ReturnType<typeof getAdminApplications>>, TError = ApiErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminApplications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminApplications>>,
          TError,
          Awaited<ReturnType<typeof getAdminApplications>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminApplications<TData = Awaited<ReturnType<typeof getAdminApplications>>, TError = ApiErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminApplications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminApplications>>,
          TError,
          Awaited<ReturnType<typeof getAdminApplications>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminApplications<TData = Awaited<ReturnType<typeof getAdminApplications>>, TError = ApiErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminApplications>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get active application adoption statistics across platform workspaces.
 */

export function useGetAdminApplications<TData = Awaited<ReturnType<typeof getAdminApplications>>, TError = ApiErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminApplications>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminApplicationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}



/**
 * @summary Get active application adoption statistics across platform workspaces.
 */
export const useSetGetAdminApplicationsQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof getAdminApplications>> | undefined | ((old: Awaited<ReturnType<typeof getAdminApplications>> | undefined) => Awaited<ReturnType<typeof getAdminApplications>> | undefined)) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof getAdminApplications>>>({ queryKey: getGetAdminApplicationsQueryKey() }, updater);
  };
}

/**
 * @summary Get active application adoption statistics across platform workspaces.
 */
export const useGetGetAdminApplicationsQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof getAdminApplications>>>(getGetAdminApplicationsQueryKey());
}


export const getGetAdminDashboardUrl = () => {




  return `/admin/dashboard`
}

/**
 * @summary Get platform admin dashboard.
 */
export const getAdminDashboard = async ( options?: RequestInit): Promise<AdminDashboardResponse> => {

  return orvalFetch<AdminDashboardResponse>(getGetAdminDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminDashboardQueryKey = () => {
    return [
    `/admin/dashboard`
    ] as const;
    }


export const getGetAdminDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getAdminDashboard>>, TError = ApiErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDashboard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminDashboard>>> = ({ signal }) => getAdminDashboard({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminDashboard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminDashboard>>>
export type GetAdminDashboardQueryError = ApiErrorResponse


export function useGetAdminDashboard<TData = Awaited<ReturnType<typeof getAdminDashboard>>, TError = ApiErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDashboard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDashboard>>,
          TError,
          Awaited<ReturnType<typeof getAdminDashboard>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminDashboard<TData = Awaited<ReturnType<typeof getAdminDashboard>>, TError = ApiErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDashboard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDashboard>>,
          TError,
          Awaited<ReturnType<typeof getAdminDashboard>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminDashboard<TData = Awaited<ReturnType<typeof getAdminDashboard>>, TError = ApiErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDashboard>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get platform admin dashboard.
 */

export function useGetAdminDashboard<TData = Awaited<ReturnType<typeof getAdminDashboard>>, TError = ApiErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDashboard>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminDashboardQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}



/**
 * @summary Get platform admin dashboard.
 */
export const useSetGetAdminDashboardQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof getAdminDashboard>> | undefined | ((old: Awaited<ReturnType<typeof getAdminDashboard>> | undefined) => Awaited<ReturnType<typeof getAdminDashboard>> | undefined)) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof getAdminDashboard>>>({ queryKey: getGetAdminDashboardQueryKey() }, updater);
  };
}

/**
 * @summary Get platform admin dashboard.
 */
export const useGetGetAdminDashboardQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof getAdminDashboard>>>(getGetAdminDashboardQueryKey());
}


export const getListAdminHistoryUrl = (params?: ListAdminHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/history?${stringifiedParams}` : `/admin/history`
}

/**
 * Recorded changes only; this is not an administrator action log or a login history. Stored actor names are preserved. Historical numeric workspace identifiers cannot reliably identify a workspace across database shards, so workspace attribution is omitted.
 * @summary List recorded workspace changes across the platform.
 */
export const listAdminHistory = async (params?: ListAdminHistoryParams, options?: RequestInit): Promise<AdminHistoryResponse> => {

  return orvalFetch<AdminHistoryResponse>(getListAdminHistoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminHistoryQueryKey = (params?: ListAdminHistoryParams,) => {
    return [
    `/admin/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminHistoryQueryOptions = <TData = Awaited<ReturnType<typeof listAdminHistory>>, TError = ApiErrorResponse>(params?: ListAdminHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminHistory>>> = ({ signal }) => listAdminHistory(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminHistory>>>
export type ListAdminHistoryQueryError = ApiErrorResponse


export function useListAdminHistory<TData = Awaited<ReturnType<typeof listAdminHistory>>, TError = ApiErrorResponse>(
 params: undefined |  ListAdminHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminHistory>>,
          TError,
          Awaited<ReturnType<typeof listAdminHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminHistory<TData = Awaited<ReturnType<typeof listAdminHistory>>, TError = ApiErrorResponse>(
 params?: ListAdminHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminHistory>>,
          TError,
          Awaited<ReturnType<typeof listAdminHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminHistory<TData = Awaited<ReturnType<typeof listAdminHistory>>, TError = ApiErrorResponse>(
 params?: ListAdminHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List recorded workspace changes across the platform.
 */

export function useListAdminHistory<TData = Awaited<ReturnType<typeof listAdminHistory>>, TError = ApiErrorResponse>(
 params?: ListAdminHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}



/**
 * @summary List recorded workspace changes across the platform.
 */
export const useSetListAdminHistoryQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ListAdminHistoryParams | undefined,updater: Awaited<ReturnType<typeof listAdminHistory>> | undefined | ((old: Awaited<ReturnType<typeof listAdminHistory>> | undefined) => Awaited<ReturnType<typeof listAdminHistory>> | undefined)) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof listAdminHistory>>>({ queryKey: getListAdminHistoryQueryKey(params) }, updater);
  };
}

/**
 * @summary List recorded workspace changes across the platform.
 */
export const useGetListAdminHistoryQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: ListAdminHistoryParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof listAdminHistory>>>(getListAdminHistoryQueryKey(params));
}


export const getGetAdminIndustriesUrl = () => {




  return `/admin/industries`
}

/**
 * @summary Get active industry installation statistics across platform workspaces.
 */
export const getAdminIndustries = async ( options?: RequestInit): Promise<AdminIndustriesResponse> => {

  return orvalFetch<AdminIndustriesResponse>(getGetAdminIndustriesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminIndustriesQueryKey = () => {
    return [
    `/admin/industries`
    ] as const;
    }


export const getGetAdminIndustriesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminIndustries>>, TError = ApiErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIndustries>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminIndustriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminIndustries>>> = ({ signal }) => getAdminIndustries({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminIndustries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminIndustriesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminIndustries>>>
export type GetAdminIndustriesQueryError = ApiErrorResponse


export function useGetAdminIndustries<TData = Awaited<ReturnType<typeof getAdminIndustries>>, TError = ApiErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIndustries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminIndustries>>,
          TError,
          Awaited<ReturnType<typeof getAdminIndustries>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminIndustries<TData = Awaited<ReturnType<typeof getAdminIndustries>>, TError = ApiErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIndustries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminIndustries>>,
          TError,
          Awaited<ReturnType<typeof getAdminIndustries>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminIndustries<TData = Awaited<ReturnType<typeof getAdminIndustries>>, TError = ApiErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIndustries>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get active industry installation statistics across platform workspaces.
 */

export function useGetAdminIndustries<TData = Awaited<ReturnType<typeof getAdminIndustries>>, TError = ApiErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIndustries>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminIndustriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}



/**
 * @summary Get active industry installation statistics across platform workspaces.
 */
export const useSetGetAdminIndustriesQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof getAdminIndustries>> | undefined | ((old: Awaited<ReturnType<typeof getAdminIndustries>> | undefined) => Awaited<ReturnType<typeof getAdminIndustries>> | undefined)) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof getAdminIndustries>>>({ queryKey: getGetAdminIndustriesQueryKey() }, updater);
  };
}

/**
 * @summary Get active industry installation statistics across platform workspaces.
 */
export const useGetGetAdminIndustriesQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof getAdminIndustries>>>(getGetAdminIndustriesQueryKey());
}


export const getListAdminIndustryWorkspacesUrl = (code: string,
    params?: ListAdminIndustryWorkspacesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/industries/${code}/workspaces?${stringifiedParams}` : `/admin/industries/${code}/workspaces`
}

/**
 * @summary List workspaces with an active industry installation.
 */
export const listAdminIndustryWorkspaces = async (code: string,
    params?: ListAdminIndustryWorkspacesParams, options?: RequestInit): Promise<AdminCatalogWorkspacesResponse> => {

  return orvalFetch<AdminCatalogWorkspacesResponse>(getListAdminIndustryWorkspacesUrl(code,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminIndustryWorkspacesQueryKey = (code: string,
    params?: ListAdminIndustryWorkspacesParams,) => {
    return [
    `/admin/industries/${code}/workspaces`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminIndustryWorkspacesQueryOptions = <TData = Awaited<ReturnType<typeof listAdminIndustryWorkspaces>>, TError = ApiErrorResponse>(code: string,
    params?: ListAdminIndustryWorkspacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminIndustryWorkspaces>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminIndustryWorkspacesQueryKey(code,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminIndustryWorkspaces>>> = ({ signal }) => listAdminIndustryWorkspaces(code,params, { signal });





   return  { queryKey, queryFn, enabled: code !== null && code !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminIndustryWorkspaces>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminIndustryWorkspacesQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminIndustryWorkspaces>>>
export type ListAdminIndustryWorkspacesQueryError = ApiErrorResponse


export function useListAdminIndustryWorkspaces<TData = Awaited<ReturnType<typeof listAdminIndustryWorkspaces>>, TError = ApiErrorResponse>(
 code: string,
    params: undefined |  ListAdminIndustryWorkspacesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminIndustryWorkspaces>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminIndustryWorkspaces>>,
          TError,
          Awaited<ReturnType<typeof listAdminIndustryWorkspaces>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminIndustryWorkspaces<TData = Awaited<ReturnType<typeof listAdminIndustryWorkspaces>>, TError = ApiErrorResponse>(
 code: string,
    params?: ListAdminIndustryWorkspacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminIndustryWorkspaces>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminIndustryWorkspaces>>,
          TError,
          Awaited<ReturnType<typeof listAdminIndustryWorkspaces>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminIndustryWorkspaces<TData = Awaited<ReturnType<typeof listAdminIndustryWorkspaces>>, TError = ApiErrorResponse>(
 code: string,
    params?: ListAdminIndustryWorkspacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminIndustryWorkspaces>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List workspaces with an active industry installation.
 */

export function useListAdminIndustryWorkspaces<TData = Awaited<ReturnType<typeof listAdminIndustryWorkspaces>>, TError = ApiErrorResponse>(
 code: string,
    params?: ListAdminIndustryWorkspacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminIndustryWorkspaces>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminIndustryWorkspacesQueryOptions(code,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}



/**
 * @summary List workspaces with an active industry installation.
 */
export const useSetListAdminIndustryWorkspacesQueryData = () => {
  const queryClient = useQueryClient();
  return (code: string,
    params: ListAdminIndustryWorkspacesParams | undefined,updater: Awaited<ReturnType<typeof listAdminIndustryWorkspaces>> | undefined | ((old: Awaited<ReturnType<typeof listAdminIndustryWorkspaces>> | undefined) => Awaited<ReturnType<typeof listAdminIndustryWorkspaces>> | undefined)) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof listAdminIndustryWorkspaces>>>({ queryKey: getListAdminIndustryWorkspacesQueryKey(code,params) }, updater);
  };
}

/**
 * @summary List workspaces with an active industry installation.
 */
export const useGetListAdminIndustryWorkspacesQueryData = () => {
  const queryClient = useQueryClient();
  return (code: string,
    params?: ListAdminIndustryWorkspacesParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof listAdminIndustryWorkspaces>>>(getListAdminIndustryWorkspacesQueryKey(code,params));
}


export const getGetAdminOperationsUrl = () => {




  return `/admin/operations`
}

/**
 * @summary Get recorded notification dispatch statistics and recent failures across assigned workspaces.
 */
export const getAdminOperations = async ( options?: RequestInit): Promise<AdminOperationsResponse> => {

  return orvalFetch<AdminOperationsResponse>(getGetAdminOperationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminOperationsQueryKey = () => {
    return [
    `/admin/operations`
    ] as const;
    }


export const getGetAdminOperationsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminOperations>>, TError = ApiErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOperations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminOperationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminOperations>>> = ({ signal }) => getAdminOperations({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminOperations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminOperationsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminOperations>>>
export type GetAdminOperationsQueryError = ApiErrorResponse


export function useGetAdminOperations<TData = Awaited<ReturnType<typeof getAdminOperations>>, TError = ApiErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOperations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminOperations>>,
          TError,
          Awaited<ReturnType<typeof getAdminOperations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminOperations<TData = Awaited<ReturnType<typeof getAdminOperations>>, TError = ApiErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOperations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminOperations>>,
          TError,
          Awaited<ReturnType<typeof getAdminOperations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminOperations<TData = Awaited<ReturnType<typeof getAdminOperations>>, TError = ApiErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOperations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get recorded notification dispatch statistics and recent failures across assigned workspaces.
 */

export function useGetAdminOperations<TData = Awaited<ReturnType<typeof getAdminOperations>>, TError = ApiErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOperations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminOperationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}



/**
 * @summary Get recorded notification dispatch statistics and recent failures across assigned workspaces.
 */
export const useSetGetAdminOperationsQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof getAdminOperations>> | undefined | ((old: Awaited<ReturnType<typeof getAdminOperations>> | undefined) => Awaited<ReturnType<typeof getAdminOperations>> | undefined)) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof getAdminOperations>>>({ queryKey: getGetAdminOperationsQueryKey() }, updater);
  };
}

/**
 * @summary Get recorded notification dispatch statistics and recent failures across assigned workspaces.
 */
export const useGetGetAdminOperationsQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof getAdminOperations>>>(getGetAdminOperationsQueryKey());
}


export const getGetAdminPartnerUrl = (workspaceUuid: string,) => {




  return `/admin/partners/${workspaceUuid}`
}

/**
 * @summary Get platform admin partner detail.
 */
export const getAdminPartner = async (workspaceUuid: string, options?: RequestInit): Promise<AdminPartnerDetailResponse> => {

  return orvalFetch<AdminPartnerDetailResponse>(getGetAdminPartnerUrl(workspaceUuid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminPartnerQueryKey = (workspaceUuid: string,) => {
    return [
    `/admin/partners/${workspaceUuid}`
    ] as const;
    }


export const getGetAdminPartnerQueryOptions = <TData = Awaited<ReturnType<typeof getAdminPartner>>, TError = ApiErrorResponse>(workspaceUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPartner>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminPartnerQueryKey(workspaceUuid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPartner>>> = ({ signal }) => getAdminPartner(workspaceUuid, { signal });





   return  { queryKey, queryFn, enabled: workspaceUuid !== null && workspaceUuid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminPartner>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminPartnerQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminPartner>>>
export type GetAdminPartnerQueryError = ApiErrorResponse


export function useGetAdminPartner<TData = Awaited<ReturnType<typeof getAdminPartner>>, TError = ApiErrorResponse>(
 workspaceUuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPartner>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPartner>>,
          TError,
          Awaited<ReturnType<typeof getAdminPartner>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPartner<TData = Awaited<ReturnType<typeof getAdminPartner>>, TError = ApiErrorResponse>(
 workspaceUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPartner>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPartner>>,
          TError,
          Awaited<ReturnType<typeof getAdminPartner>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPartner<TData = Awaited<ReturnType<typeof getAdminPartner>>, TError = ApiErrorResponse>(
 workspaceUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPartner>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get platform admin partner detail.
 */

export function useGetAdminPartner<TData = Awaited<ReturnType<typeof getAdminPartner>>, TError = ApiErrorResponse>(
 workspaceUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPartner>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminPartnerQueryOptions(workspaceUuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}



/**
 * @summary Get platform admin partner detail.
 */
export const useSetGetAdminPartnerQueryData = () => {
  const queryClient = useQueryClient();
  return (workspaceUuid: string,updater: Awaited<ReturnType<typeof getAdminPartner>> | undefined | ((old: Awaited<ReturnType<typeof getAdminPartner>> | undefined) => Awaited<ReturnType<typeof getAdminPartner>> | undefined)) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof getAdminPartner>>>({ queryKey: getGetAdminPartnerQueryKey(workspaceUuid) }, updater);
  };
}

/**
 * @summary Get platform admin partner detail.
 */
export const useGetGetAdminPartnerQueryData = () => {
  const queryClient = useQueryClient();
  return (workspaceUuid: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof getAdminPartner>>>(getGetAdminPartnerQueryKey(workspaceUuid));
}


export const getListAdminPartnersUrl = (params?: ListAdminPartnersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/partners?${stringifiedParams}` : `/admin/partners`
}

/**
 * @summary List platform admin partners.
 */
export const listAdminPartners = async (params?: ListAdminPartnersParams, options?: RequestInit): Promise<AdminPartnerListResponse> => {

  return orvalFetch<AdminPartnerListResponse>(getListAdminPartnersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminPartnersQueryKey = (params?: ListAdminPartnersParams,) => {
    return [
    `/admin/partners`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminPartnersQueryOptions = <TData = Awaited<ReturnType<typeof listAdminPartners>>, TError = ApiErrorResponse>(params?: ListAdminPartnersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminPartners>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminPartnersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminPartners>>> = ({ signal }) => listAdminPartners(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminPartners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminPartnersQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminPartners>>>
export type ListAdminPartnersQueryError = ApiErrorResponse


export function useListAdminPartners<TData = Awaited<ReturnType<typeof listAdminPartners>>, TError = ApiErrorResponse>(
 params: undefined |  ListAdminPartnersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminPartners>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminPartners>>,
          TError,
          Awaited<ReturnType<typeof listAdminPartners>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminPartners<TData = Awaited<ReturnType<typeof listAdminPartners>>, TError = ApiErrorResponse>(
 params?: ListAdminPartnersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminPartners>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminPartners>>,
          TError,
          Awaited<ReturnType<typeof listAdminPartners>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminPartners<TData = Awaited<ReturnType<typeof listAdminPartners>>, TError = ApiErrorResponse>(
 params?: ListAdminPartnersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminPartners>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List platform admin partners.
 */

export function useListAdminPartners<TData = Awaited<ReturnType<typeof listAdminPartners>>, TError = ApiErrorResponse>(
 params?: ListAdminPartnersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminPartners>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminPartnersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}



/**
 * @summary List platform admin partners.
 */
export const useSetListAdminPartnersQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ListAdminPartnersParams | undefined,updater: Awaited<ReturnType<typeof listAdminPartners>> | undefined | ((old: Awaited<ReturnType<typeof listAdminPartners>> | undefined) => Awaited<ReturnType<typeof listAdminPartners>> | undefined)) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof listAdminPartners>>>({ queryKey: getListAdminPartnersQueryKey(params) }, updater);
  };
}

/**
 * @summary List platform admin partners.
 */
export const useGetListAdminPartnersQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: ListAdminPartnersParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof listAdminPartners>>>(getListAdminPartnersQueryKey(params));
}


export const getListAdminUsersUrl = (params?: ListAdminUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/users/list?${stringifiedParams}` : `/admin/users/list`
}

/**
 * @summary List platform users and their current workspace membership counts.
 */
export const listAdminUsers = async (params?: ListAdminUsersParams, options?: RequestInit): Promise<AdminUserListResponse> => {

  return orvalFetch<AdminUserListResponse>(getListAdminUsersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminUsersQueryKey = (params?: ListAdminUsersParams,) => {
    return [
    `/admin/users/list`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminUsersQueryOptions = <TData = Awaited<ReturnType<typeof listAdminUsers>>, TError = ApiErrorResponse>(params?: ListAdminUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminUsers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminUsers>>> = ({ signal }) => listAdminUsers(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminUsers>>>
export type ListAdminUsersQueryError = ApiErrorResponse


export function useListAdminUsers<TData = Awaited<ReturnType<typeof listAdminUsers>>, TError = ApiErrorResponse>(
 params: undefined |  ListAdminUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminUsers>>,
          TError,
          Awaited<ReturnType<typeof listAdminUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminUsers<TData = Awaited<ReturnType<typeof listAdminUsers>>, TError = ApiErrorResponse>(
 params?: ListAdminUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminUsers>>,
          TError,
          Awaited<ReturnType<typeof listAdminUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminUsers<TData = Awaited<ReturnType<typeof listAdminUsers>>, TError = ApiErrorResponse>(
 params?: ListAdminUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List platform users and their current workspace membership counts.
 */

export function useListAdminUsers<TData = Awaited<ReturnType<typeof listAdminUsers>>, TError = ApiErrorResponse>(
 params?: ListAdminUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}



/**
 * @summary List platform users and their current workspace membership counts.
 */
export const useSetListAdminUsersQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ListAdminUsersParams | undefined,updater: Awaited<ReturnType<typeof listAdminUsers>> | undefined | ((old: Awaited<ReturnType<typeof listAdminUsers>> | undefined) => Awaited<ReturnType<typeof listAdminUsers>> | undefined)) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof listAdminUsers>>>({ queryKey: getListAdminUsersQueryKey(params) }, updater);
  };
}

/**
 * @summary List platform users and their current workspace membership counts.
 */
export const useGetListAdminUsersQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: ListAdminUsersParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof listAdminUsers>>>(getListAdminUsersQueryKey(params));
}


export const getGetAdminUsersUrl = () => {




  return `/admin/users`
}

/**
 * @summary Get platform user registration statistics and the five newest users.
 */
export const getAdminUsers = async ( options?: RequestInit): Promise<AdminUsersResponse> => {

  return orvalFetch<AdminUsersResponse>(getGetAdminUsersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminUsersQueryKey = () => {
    return [
    `/admin/users`
    ] as const;
    }


export const getGetAdminUsersQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUsers>>, TError = ApiErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUsersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUsers>>> = ({ signal }) => getAdminUsers({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUsers>>>
export type GetAdminUsersQueryError = ApiErrorResponse


export function useGetAdminUsers<TData = Awaited<ReturnType<typeof getAdminUsers>>, TError = ApiErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminUsers>>,
          TError,
          Awaited<ReturnType<typeof getAdminUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminUsers<TData = Awaited<ReturnType<typeof getAdminUsers>>, TError = ApiErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminUsers>>,
          TError,
          Awaited<ReturnType<typeof getAdminUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminUsers<TData = Awaited<ReturnType<typeof getAdminUsers>>, TError = ApiErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get platform user registration statistics and the five newest users.
 */

export function useGetAdminUsers<TData = Awaited<ReturnType<typeof getAdminUsers>>, TError = ApiErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminUsersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}



/**
 * @summary Get platform user registration statistics and the five newest users.
 */
export const useSetGetAdminUsersQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof getAdminUsers>> | undefined | ((old: Awaited<ReturnType<typeof getAdminUsers>> | undefined) => Awaited<ReturnType<typeof getAdminUsers>> | undefined)) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof getAdminUsers>>>({ queryKey: getGetAdminUsersQueryKey() }, updater);
  };
}

/**
 * @summary Get platform user registration statistics and the five newest users.
 */
export const useGetGetAdminUsersQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof getAdminUsers>>>(getGetAdminUsersQueryKey());
}


export const getChangeAdminPartnerCommissionUrl = (partnerUuid: string,) => {




  return `/admin/partner-accounts/${partnerUuid}/commission`
}

/**
 * @summary Set an individual commission rate or restore the default rate.
 */
export const changeAdminPartnerCommission = async (partnerUuid: string,
    adminChangePartnerCommissionRequest: AdminChangePartnerCommissionRequest, options?: RequestInit): Promise<void> => {

  return orvalFetch<void>(getChangeAdminPartnerCommissionUrl(partnerUuid),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminChangePartnerCommissionRequest)
  }
);}





export const getChangeAdminPartnerCommissionMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeAdminPartnerCommission>>, TError,{partnerUuid: string;data: AdminChangePartnerCommissionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof changeAdminPartnerCommission>>, TError,{partnerUuid: string;data: AdminChangePartnerCommissionRequest}, TContext> => {

const mutationKey = ['changeAdminPartnerCommission'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeAdminPartnerCommission>>, {partnerUuid: string;data: AdminChangePartnerCommissionRequest}> = (props) => {
          const {partnerUuid,data} = props ?? {};

          return  changeAdminPartnerCommission(partnerUuid,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangeAdminPartnerCommissionMutationResult = NonNullable<Awaited<ReturnType<typeof changeAdminPartnerCommission>>>
    export type ChangeAdminPartnerCommissionMutationBody = AdminChangePartnerCommissionRequest
    export type ChangeAdminPartnerCommissionMutationError = ApiErrorResponse

    /**
 * @summary Set an individual commission rate or restore the default rate.
 */
export const useChangeAdminPartnerCommission = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeAdminPartnerCommission>>, TError,{partnerUuid: string;data: AdminChangePartnerCommissionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeAdminPartnerCommission>>,
        TError,
        {partnerUuid: string;data: AdminChangePartnerCommissionRequest},
        TContext
      > => {
      return useMutation(getChangeAdminPartnerCommissionMutationOptions(options), queryClient);
    }
    export const getListAdminPartnerAccountsUrl = (params?: ListAdminPartnerAccountsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/partner-accounts?${stringifiedParams}` : `/admin/partner-accounts`
}

/**
 * @summary List ambassador accounts and their referral results.
 */
export const listAdminPartnerAccounts = async (params?: ListAdminPartnerAccountsParams, options?: RequestInit): Promise<AdminPartnerAccountListResponse> => {

  return orvalFetch<AdminPartnerAccountListResponse>(getListAdminPartnerAccountsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminPartnerAccountsQueryKey = (params?: ListAdminPartnerAccountsParams,) => {
    return [
    `/admin/partner-accounts`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminPartnerAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminPartnerAccounts>>, TError = ApiErrorResponse>(params?: ListAdminPartnerAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminPartnerAccounts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminPartnerAccountsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminPartnerAccounts>>> = ({ signal }) => listAdminPartnerAccounts(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminPartnerAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminPartnerAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminPartnerAccounts>>>
export type ListAdminPartnerAccountsQueryError = ApiErrorResponse


export function useListAdminPartnerAccounts<TData = Awaited<ReturnType<typeof listAdminPartnerAccounts>>, TError = ApiErrorResponse>(
 params: undefined |  ListAdminPartnerAccountsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminPartnerAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminPartnerAccounts>>,
          TError,
          Awaited<ReturnType<typeof listAdminPartnerAccounts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminPartnerAccounts<TData = Awaited<ReturnType<typeof listAdminPartnerAccounts>>, TError = ApiErrorResponse>(
 params?: ListAdminPartnerAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminPartnerAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminPartnerAccounts>>,
          TError,
          Awaited<ReturnType<typeof listAdminPartnerAccounts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminPartnerAccounts<TData = Awaited<ReturnType<typeof listAdminPartnerAccounts>>, TError = ApiErrorResponse>(
 params?: ListAdminPartnerAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminPartnerAccounts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List ambassador accounts and their referral results.
 */

export function useListAdminPartnerAccounts<TData = Awaited<ReturnType<typeof listAdminPartnerAccounts>>, TError = ApiErrorResponse>(
 params?: ListAdminPartnerAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminPartnerAccounts>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminPartnerAccountsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}



/**
 * @summary List ambassador accounts and their referral results.
 */
export const useSetListAdminPartnerAccountsQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ListAdminPartnerAccountsParams | undefined,updater: Awaited<ReturnType<typeof listAdminPartnerAccounts>> | undefined | ((old: Awaited<ReturnType<typeof listAdminPartnerAccounts>> | undefined) => Awaited<ReturnType<typeof listAdminPartnerAccounts>> | undefined)) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof listAdminPartnerAccounts>>>({ queryKey: getListAdminPartnerAccountsQueryKey(params) }, updater);
  };
}

/**
 * @summary List ambassador accounts and their referral results.
 */
export const useGetListAdminPartnerAccountsQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: ListAdminPartnerAccountsParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof listAdminPartnerAccounts>>>(getListAdminPartnerAccountsQueryKey(params));
}


export const getChangeAdminPartnerAccountStatusUrl = (partnerUuid: string,) => {




  return `/admin/partner-accounts/${partnerUuid}/status`
}

/**
 * @summary Suspend or reactivate an ambassador account.
 */
export const changeAdminPartnerAccountStatus = async (partnerUuid: string,
    adminChangePartnerAccountStatusRequest: AdminChangePartnerAccountStatusRequest, options?: RequestInit): Promise<void> => {

  return orvalFetch<void>(getChangeAdminPartnerAccountStatusUrl(partnerUuid),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminChangePartnerAccountStatusRequest)
  }
);}





export const getChangeAdminPartnerAccountStatusMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeAdminPartnerAccountStatus>>, TError,{partnerUuid: string;data: AdminChangePartnerAccountStatusRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof changeAdminPartnerAccountStatus>>, TError,{partnerUuid: string;data: AdminChangePartnerAccountStatusRequest}, TContext> => {

const mutationKey = ['changeAdminPartnerAccountStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeAdminPartnerAccountStatus>>, {partnerUuid: string;data: AdminChangePartnerAccountStatusRequest}> = (props) => {
          const {partnerUuid,data} = props ?? {};

          return  changeAdminPartnerAccountStatus(partnerUuid,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangeAdminPartnerAccountStatusMutationResult = NonNullable<Awaited<ReturnType<typeof changeAdminPartnerAccountStatus>>>
    export type ChangeAdminPartnerAccountStatusMutationBody = AdminChangePartnerAccountStatusRequest
    export type ChangeAdminPartnerAccountStatusMutationError = ApiErrorResponse

    /**
 * @summary Suspend or reactivate an ambassador account.
 */
export const useChangeAdminPartnerAccountStatus = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeAdminPartnerAccountStatus>>, TError,{partnerUuid: string;data: AdminChangePartnerAccountStatusRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeAdminPartnerAccountStatus>>,
        TError,
        {partnerUuid: string;data: AdminChangePartnerAccountStatusRequest},
        TContext
      > => {
      return useMutation(getChangeAdminPartnerAccountStatusMutationOptions(options), queryClient);
    }
    export const getGetAdminSupportConversationUrl = (conversationUuid: string,) => {




  return `/admin/support/conversations/${conversationUuid}`
}

/**
 * @summary Read a client support conversation.
 */
export const getAdminSupportConversation = async (conversationUuid: string, options?: RequestInit): Promise<SupportConversationDetailDto> => {

  return orvalFetch<SupportConversationDetailDto>(getGetAdminSupportConversationUrl(conversationUuid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminSupportConversationQueryKey = (conversationUuid: string,) => {
    return [
    `/admin/support/conversations/${conversationUuid}`
    ] as const;
    }


export const getGetAdminSupportConversationQueryOptions = <TData = Awaited<ReturnType<typeof getAdminSupportConversation>>, TError = ApiErrorResponse>(conversationUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSupportConversation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminSupportConversationQueryKey(conversationUuid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminSupportConversation>>> = ({ signal }) => getAdminSupportConversation(conversationUuid, { signal });





   return  { queryKey, queryFn, enabled: conversationUuid !== null && conversationUuid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminSupportConversation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminSupportConversationQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminSupportConversation>>>
export type GetAdminSupportConversationQueryError = ApiErrorResponse


export function useGetAdminSupportConversation<TData = Awaited<ReturnType<typeof getAdminSupportConversation>>, TError = ApiErrorResponse>(
 conversationUuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSupportConversation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminSupportConversation>>,
          TError,
          Awaited<ReturnType<typeof getAdminSupportConversation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminSupportConversation<TData = Awaited<ReturnType<typeof getAdminSupportConversation>>, TError = ApiErrorResponse>(
 conversationUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSupportConversation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminSupportConversation>>,
          TError,
          Awaited<ReturnType<typeof getAdminSupportConversation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminSupportConversation<TData = Awaited<ReturnType<typeof getAdminSupportConversation>>, TError = ApiErrorResponse>(
 conversationUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSupportConversation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read a client support conversation.
 */

export function useGetAdminSupportConversation<TData = Awaited<ReturnType<typeof getAdminSupportConversation>>, TError = ApiErrorResponse>(
 conversationUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSupportConversation>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminSupportConversationQueryOptions(conversationUuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}



/**
 * @summary Read a client support conversation.
 */
export const useSetGetAdminSupportConversationQueryData = () => {
  const queryClient = useQueryClient();
  return (conversationUuid: string,updater: Awaited<ReturnType<typeof getAdminSupportConversation>> | undefined | ((old: Awaited<ReturnType<typeof getAdminSupportConversation>> | undefined) => Awaited<ReturnType<typeof getAdminSupportConversation>> | undefined)) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof getAdminSupportConversation>>>({ queryKey: getGetAdminSupportConversationQueryKey(conversationUuid) }, updater);
  };
}

/**
 * @summary Read a client support conversation.
 */
export const useGetGetAdminSupportConversationQueryData = () => {
  const queryClient = useQueryClient();
  return (conversationUuid: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof getAdminSupportConversation>>>(getGetAdminSupportConversationQueryKey(conversationUuid));
}


export const getListAdminSupportConversationsUrl = (params?: ListAdminSupportConversationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/support/conversations?${stringifiedParams}` : `/admin/support/conversations`
}

/**
 * @summary List private client support conversations.
 */
export const listAdminSupportConversations = async (params?: ListAdminSupportConversationsParams, options?: RequestInit): Promise<SupportConversationListResponse> => {

  return orvalFetch<SupportConversationListResponse>(getListAdminSupportConversationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminSupportConversationsQueryKey = (params?: ListAdminSupportConversationsParams,) => {
    return [
    `/admin/support/conversations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminSupportConversationsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminSupportConversations>>, TError = ApiErrorResponse>(params?: ListAdminSupportConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminSupportConversations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminSupportConversationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminSupportConversations>>> = ({ signal }) => listAdminSupportConversations(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminSupportConversations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminSupportConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminSupportConversations>>>
export type ListAdminSupportConversationsQueryError = ApiErrorResponse


export function useListAdminSupportConversations<TData = Awaited<ReturnType<typeof listAdminSupportConversations>>, TError = ApiErrorResponse>(
 params: undefined |  ListAdminSupportConversationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminSupportConversations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminSupportConversations>>,
          TError,
          Awaited<ReturnType<typeof listAdminSupportConversations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminSupportConversations<TData = Awaited<ReturnType<typeof listAdminSupportConversations>>, TError = ApiErrorResponse>(
 params?: ListAdminSupportConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminSupportConversations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminSupportConversations>>,
          TError,
          Awaited<ReturnType<typeof listAdminSupportConversations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminSupportConversations<TData = Awaited<ReturnType<typeof listAdminSupportConversations>>, TError = ApiErrorResponse>(
 params?: ListAdminSupportConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminSupportConversations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List private client support conversations.
 */

export function useListAdminSupportConversations<TData = Awaited<ReturnType<typeof listAdminSupportConversations>>, TError = ApiErrorResponse>(
 params?: ListAdminSupportConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminSupportConversations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminSupportConversationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}



/**
 * @summary List private client support conversations.
 */
export const useSetListAdminSupportConversationsQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ListAdminSupportConversationsParams | undefined,updater: Awaited<ReturnType<typeof listAdminSupportConversations>> | undefined | ((old: Awaited<ReturnType<typeof listAdminSupportConversations>> | undefined) => Awaited<ReturnType<typeof listAdminSupportConversations>> | undefined)) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof listAdminSupportConversations>>>({ queryKey: getListAdminSupportConversationsQueryKey(params) }, updater);
  };
}

/**
 * @summary List private client support conversations.
 */
export const useGetListAdminSupportConversationsQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: ListAdminSupportConversationsParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof listAdminSupportConversations>>>(getListAdminSupportConversationsQueryKey(params));
}


export const getUpdateAdminSupportConversationStatusUrl = (conversationUuid: string,) => {




  return `/admin/support/conversations/${conversationUuid}/status`
}

/**
 * @summary Resolve or reopen a support conversation.
 */
export const updateAdminSupportConversationStatus = async (conversationUuid: string,
    updateAdminSupportConversationStatusRequest: UpdateAdminSupportConversationStatusRequest, options?: RequestInit): Promise<SupportConversationDetailDto> => {

  return orvalFetch<SupportConversationDetailDto>(getUpdateAdminSupportConversationStatusUrl(conversationUuid),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateAdminSupportConversationStatusRequest)
  }
);}





export const getUpdateAdminSupportConversationStatusMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminSupportConversationStatus>>, TError,{conversationUuid: string;data: UpdateAdminSupportConversationStatusRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminSupportConversationStatus>>, TError,{conversationUuid: string;data: UpdateAdminSupportConversationStatusRequest}, TContext> => {

const mutationKey = ['updateAdminSupportConversationStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminSupportConversationStatus>>, {conversationUuid: string;data: UpdateAdminSupportConversationStatusRequest}> = (props) => {
          const {conversationUuid,data} = props ?? {};

          return  updateAdminSupportConversationStatus(conversationUuid,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminSupportConversationStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminSupportConversationStatus>>>
    export type UpdateAdminSupportConversationStatusMutationBody = UpdateAdminSupportConversationStatusRequest
    export type UpdateAdminSupportConversationStatusMutationError = ApiErrorResponse

    /**
 * @summary Resolve or reopen a support conversation.
 */
export const useUpdateAdminSupportConversationStatus = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminSupportConversationStatus>>, TError,{conversationUuid: string;data: UpdateAdminSupportConversationStatusRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAdminSupportConversationStatus>>,
        TError,
        {conversationUuid: string;data: UpdateAdminSupportConversationStatusRequest},
        TContext
      > => {
      return useMutation(getUpdateAdminSupportConversationStatusMutationOptions(options), queryClient);
    }
    export const getSendAdminSupportMessageUrl = (conversationUuid: string,) => {




  return `/admin/support/conversations/${conversationUuid}/messages`
}

/**
 * @summary Reply to a client as TAKERES support.
 */
export const sendAdminSupportMessage = async (conversationUuid: string,
    sendAdminSupportMessageRequest: SendAdminSupportMessageRequest, options?: RequestInit): Promise<SupportConversationDetailDto> => {

  return orvalFetch<SupportConversationDetailDto>(getSendAdminSupportMessageUrl(conversationUuid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sendAdminSupportMessageRequest)
  }
);}





export const getSendAdminSupportMessageMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAdminSupportMessage>>, TError,{conversationUuid: string;data: SendAdminSupportMessageRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendAdminSupportMessage>>, TError,{conversationUuid: string;data: SendAdminSupportMessageRequest}, TContext> => {

const mutationKey = ['sendAdminSupportMessage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendAdminSupportMessage>>, {conversationUuid: string;data: SendAdminSupportMessageRequest}> = (props) => {
          const {conversationUuid,data} = props ?? {};

          return  sendAdminSupportMessage(conversationUuid,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendAdminSupportMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendAdminSupportMessage>>>
    export type SendAdminSupportMessageMutationBody = SendAdminSupportMessageRequest
    export type SendAdminSupportMessageMutationError = ApiErrorResponse

    /**
 * @summary Reply to a client as TAKERES support.
 */
export const useSendAdminSupportMessage = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAdminSupportMessage>>, TError,{conversationUuid: string;data: SendAdminSupportMessageRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendAdminSupportMessage>>,
        TError,
        {conversationUuid: string;data: SendAdminSupportMessageRequest},
        TContext
      > => {
      return useMutation(getSendAdminSupportMessageMutationOptions(options), queryClient);
    }
    export const getGetAdminUserDetailUrl = (userUuid: string,) => {




  return `/admin/users/${userUuid}`
}

/**
 * @summary Get a platform user and their current workspace memberships.
 */
export const getAdminUserDetail = async (userUuid: string, options?: RequestInit): Promise<AdminUserDetailResponse> => {

  return orvalFetch<AdminUserDetailResponse>(getGetAdminUserDetailUrl(userUuid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminUserDetailQueryKey = (userUuid: string,) => {
    return [
    `/admin/users/${userUuid}`
    ] as const;
    }


export const getGetAdminUserDetailQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUserDetail>>, TError = ApiErrorResponse>(userUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUserDetail>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUserDetailQueryKey(userUuid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUserDetail>>> = ({ signal }) => getAdminUserDetail(userUuid, { signal });





   return  { queryKey, queryFn, enabled: userUuid !== null && userUuid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUserDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminUserDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUserDetail>>>
export type GetAdminUserDetailQueryError = ApiErrorResponse


export function useGetAdminUserDetail<TData = Awaited<ReturnType<typeof getAdminUserDetail>>, TError = ApiErrorResponse>(
 userUuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUserDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminUserDetail>>,
          TError,
          Awaited<ReturnType<typeof getAdminUserDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminUserDetail<TData = Awaited<ReturnType<typeof getAdminUserDetail>>, TError = ApiErrorResponse>(
 userUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUserDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminUserDetail>>,
          TError,
          Awaited<ReturnType<typeof getAdminUserDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminUserDetail<TData = Awaited<ReturnType<typeof getAdminUserDetail>>, TError = ApiErrorResponse>(
 userUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUserDetail>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a platform user and their current workspace memberships.
 */

export function useGetAdminUserDetail<TData = Awaited<ReturnType<typeof getAdminUserDetail>>, TError = ApiErrorResponse>(
 userUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUserDetail>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminUserDetailQueryOptions(userUuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}



/**
 * @summary Get a platform user and their current workspace memberships.
 */
export const useSetGetAdminUserDetailQueryData = () => {
  const queryClient = useQueryClient();
  return (userUuid: string,updater: Awaited<ReturnType<typeof getAdminUserDetail>> | undefined | ((old: Awaited<ReturnType<typeof getAdminUserDetail>> | undefined) => Awaited<ReturnType<typeof getAdminUserDetail>> | undefined)) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof getAdminUserDetail>>>({ queryKey: getGetAdminUserDetailQueryKey(userUuid) }, updater);
  };
}

/**
 * @summary Get a platform user and their current workspace memberships.
 */
export const useGetGetAdminUserDetailQueryData = () => {
  const queryClient = useQueryClient();
  return (userUuid: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof getAdminUserDetail>>>(getGetAdminUserDetailQueryKey(userUuid));
}
